/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useRef } from 'react';
import Page from 'components/custom/template/Page';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import employeeAttendenceListColumns from './employeeAttendenceListColumns';

const EmployeeListDetails = data => {
  const [pageLoading, loadingMessage, handleLoading] = useManagePageLoading();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const refreshDataRef = useRef(null);
  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };

  const handleAllowCasualBreak = async value => {
    const request = await postData(
      value,
      `${apiEndpoints.punch.allowCasualBreak}/${value}`
    );
    if (request.status) {
      showAlert({
        variant: 'info',
        message: `Reset Punch has been successfully raised.`
      });
      handleRefresh();
      handleClose();
    } else {
      showAlert({
        variant: 'danger',
        message: `Failed to Reset Punch.`
      });
    }
  };
  const handleAllowPunchOut = async value => {
    const request = await postData(value, apiEndpoints.punch.reset);
    if (request.status) {
      showAlert({
        variant: 'info',
        message: `Reset Punch has been successfully raised.`
      });
      handleRefresh();
      handleClose();
    } else {
      showAlert({
        variant: 'danger',
        message: `Failed to Reset Punch.`
      });
    }
  };

  const actions = original => ({
    otherActions: [
      {
        label: 'Allow punch in',
        icon: 'fluent:arrow-reset-32-filled',
        action: () => handleAllowPunchOut(original)
      },
      {
        label: 'Allow Casual Break',
        icon: 'heroicons-outline:check',
        action: () => handleAllowCasualBreak(original)
      }
    ]
  });

  return (
    <div className='p-3'>
      <Page
        tableColumn={{
          column: employeeAttendenceListColumns({}),
          actions
        }}
        urlEndPoint={apiEndpoints.attendance.getEmployeeAttendance(
          data.data.personal_information.employee_id
        )}
        exportName="attendence list"
        backdrop={{ message: loadingMessage, loading: pageLoading }}
        onRegisterRefresh={handleRefreshDataRegister}
        dataWithDateRange={false}
        dataFormatter={data => data.toReversed()}
      ></Page>
    </div>
  );
};

export default EmployeeListDetails;
